import { formatNumber } from "@utils/formatValues";
import Photo from "@components/new/Photo";
import { TableRowType, TableCellLink, TableColumn } from "@components/new/Table";
import { TRow } from "./types";
// import styles from './Form.module.scss';

function getItemsColumns(
  t: (v: string) => string,
  //selectedItems: TRow[],
  //setSelectedItems: ((v: TRow[] | ((v: TRow[]) => TRow[])) => void),
): TableColumn<TRow>[] {
  return [
    {
      header: t("fbpPage.delStoreModal.columns.photo"),
      renderCell: (row: TableRowType<TRow>) => (
        <Photo src={row.data.primaryImage} />
      ),
      width: "80px",
      fixWidth: true,
    },
    {
      header: t("fbpPage.delStoreModal.columns.name"),
      renderCell: (row: TableRowType<TRow>) => {
        const description = row.data.sku;
        return (
          <TableCellLink
            title={row.data.name}
            description={description}
            to={row.data.url}
            external
            maxWidth="460px"
          />
        )
      },
      width: "500px",
    },
    {
      header: t("fbpPage.delStoreModal.columns.size"),
      valueGetter: (row: TRow) => (row.size || ""),
      width: "80px",
      fixWidth: true,
      alignment: "center",
    },
    {
      header: t("fbpPage.delStoreModal.columns.count"),
      renderCell: (row: TableRowType<TRow>) => formatNumber(row.data.present),
      width: "100px",
      fixWidth: true,
    },
  ]
}

export default getItemsColumns
